export const content = `
<section>
  <h2>La dette technique : le tueur silencieux</h2>
  <p>
    Beaucoup d'entreprises attendent la panne majeure pour agir. Pourtant, le code "Legacy" envoie des signaux d'alerte bien avant.
  </p>
</section>

<hr>

<section>
  <h2>1. Le Fear-Driven Development</h2>
  <p>
    Si vos développeurs ont peur de modifier une ligne de code par crainte de tout casser, votre agilité est déjà à zéro. Le manque de tests crée un climat d'insécurité qui paralyse l'innovation.
  </p>
</section>

<hr>

<section>
  <h2>2. Le temps d’onboarding s’envole</h2>
  <p>
    S'il faut plus de 3 semaines à un nouveau développeur pour être productif, l'architecture est devenue trop complexe ou obsolète. Un code sain doit être explicite et documenté.
  </p>
</section>

<hr>

<section>
  <h2>3. Les bugs récurrents (Effet Hydra)</h2>
  <p>
    Vous corrigez un bug, et deux nouveaux apparaissent ailleurs. C'est le signe d'un couplage trop fort.
  </p>
</section>

<hr>

<section>
  <h2>Conclusion</h2>
  <p>
    Un audit technique de 3 jours peut vous faire gagner des mois de développement futur. Ne laissez pas la dette technique piloter votre roadmap.
  </p>
</section>

<div class="content-cta">
  <h3>Demander un audit flash</h3>
  <p>Transformez votre dette technique en levier de croissance dès aujourd'hui.</p>
  <a href="/contact" class="button primary">Demander un audit</a>
</div>
`;
